import { Component } from '@angular/core';
import { FeatureFlags, CustomerAccount } from '@inyova/models';

import { select, Store } from '@ngrx/store';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import * as fromAppRoot from 'src/app/app.reducers';

@Component({
  selector: 'app-strategy-risk-recheck',
  templateUrl: './strategy-risk-recheck.component.html',
  styleUrls: ['./strategy-risk-recheck.component.scss'],
  standalone: false
})
export class StrategyRiskRecheckComponent {
  protected readonly onDestroy$ = new Subject<void>();
  currentAccount: CustomerAccount;
  isEve2: boolean;

  constructor(private store: Store) {
    this.store.pipe(select(fromAppRoot.selectCustomerAndCurrentInvestAccount), takeUntil(this.onDestroy$)).subscribe((value) => {
      if (!value.customer || !value.customer.email || !value.currentAccountDetail?.onboarding_step) {
        return;
      }
      this.currentAccount = value.currentAccountDetail;
    });

    this.store.pipe(select(fromAppRoot.selectAccountFeatureFlag(FeatureFlags.EVE2)), takeUntil(this.onDestroy$)).subscribe((value) => {
      this.isEve2 = value;
    });
  }
}
